import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../shared/links';
import styles from './AgreementTextV4.css';

const cx = classnames.bind(styles);

function AgreementTextV4({ className, legalLinks = { privacyPolicy: PRIVACY_POLICY_LINK, termsOfUse: TERMS_OF_USE_LINK } }) {
    return (
        <p className={cx('agreementText', className)}>
            {'By continuing, you agree to our '}
            <CustomLink
                to={legalLinks.termsOfUse}
                target='_blank'
            >
                Terms&nbsp;of&nbsp;Service
            </CustomLink>
            {' and '}
            <CustomLink
                to={legalLinks.privacyPolicy}
                target='_blank'
            >
                Privacy&nbsp;Policy
            </CustomLink>
            . See our Notice at Collection.
        </p>
    );
}

AgreementTextV4.propTypes = {
    className: PropTypes.string,
    legalLinks: PropTypes.object
};

export {
    AgreementTextV4
};
